export default __webpack_public_path__ + "static/media/chapter5.87d40b40.jpg";